import React from 'react';

// Inlined Ably wordmark so the auth surface doesn't depend on `@ably/ui`'s
// `Logo` (the org is retiring `@ably/ui`, DXDR-005). Matches the 96px render
// width `@ably/ui` used, preserving the 204x64 aspect ratio.
export function Logo({ className }: { className?: string }) {
  return (
    <svg
      width="96"
      height="34"
      viewBox="0 -4 204 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Ably"
      className={className}
    >
      <path
        d="M125.844 49.9572V8.17627H133.387V23.3024C135.942 20.87 139.233 19.5209 142.708 19.5209C150.864 19.5209 158.1 25.7349 158.1 35.0967C158.1 44.4586 150.864 50.693 142.708 50.693C139.049 50.693 135.594 49.2417 133.019 46.6049V49.9572H125.844ZM150.557 35.0967C150.557 29.8639 146.837 26.205 141.972 26.205C137.23 26.205 133.571 29.6799 133.387 34.7288V35.0967C133.387 40.3296 137.107 43.9885 141.972 43.9885C146.837 43.9885 150.557 40.3296 150.557 35.0967ZM161.595 49.9572V8.17627H169.138V49.9572H161.595ZM179.685 60.7908L184.08 50.3047L172.142 20.2568H180.298L187.902 41.2494L195.629 20.2568H203.907L187.718 60.8112H179.685V60.7908ZM113.866 20.2568V24.0383C111.249 21.1766 107.59 19.5413 103.829 19.5413C95.6735 19.5413 88.4374 25.7553 88.4374 35.1172C88.4374 44.4995 95.6735 50.693 103.829 50.693C107.734 50.693 111.433 48.9965 114.111 45.9508V49.9776H120.693V20.2568H113.866ZM113.13 35.0967C113.13 40.2683 109.41 43.9885 104.545 43.9885C99.6799 43.9885 95.9596 40.2683 95.9596 35.0967C95.9596 29.9252 99.6799 26.205 104.545 26.205C109.287 26.205 112.946 29.7413 113.13 34.7288V35.0967Z"
        fill="#03020D"
      />
      <path
        d="M38.5717 0L6.29575 59.0738L0 54.6586L29.8639 0H38.5717ZM39.0214 0L71.2973 59.0738L77.5931 54.6586L47.7292 0H39.0214Z"
        fill="url(#ably-logo-a)"
      />
      <path
        d="M70.8476 59.4213L38.7965 34.3201L6.74542 59.4213L13.2865 64L38.7965 44.0294L64.3066 64L70.8476 59.4213Z"
        fill="url(#ably-logo-b)"
      />
      <defs>
        <linearGradient
          id="ably-logo-a"
          x1="10.9472"
          y1="74.8439"
          x2="64.9206"
          y2="14.9005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5416" />
          <stop offset="0.2535" stopColor="#FF5115" />
          <stop offset="0.461" stopColor="#FF4712" />
          <stop offset="0.6523" stopColor="#FF350E" />
          <stop offset="0.8327" stopColor="#FF1E08" />
          <stop offset="1" stopColor="#FF0000" />
        </linearGradient>
        <linearGradient
          id="ably-logo-b"
          x1="21.4168"
          y1="78.7187"
          x2="53.3166"
          y2="43.2904"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5416" />
          <stop offset="0.2535" stopColor="#FF5115" />
          <stop offset="0.461" stopColor="#FF4712" />
          <stop offset="0.6523" stopColor="#FF350E" />
          <stop offset="0.8327" stopColor="#FF1E08" />
          <stop offset="1" stopColor="#FF0000" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Logo;
